import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import styles from '../../../components/EditMenu.module.scss';

const link = cx(styles.link, 'd-flex', 'align-items-center', 'px-3', 'py-2');

const UserEditMenu = ({ onEdit, onDeactivate, status, onActivate, loadingAction }) => (
  <ul
    className={cx(styles.editMenu, 'radius-4', 'bg-white', 'py-2', 'px-0')}
    onClick={(e) => {
      e.stopPropagation();
    }}
  >
    <li className={cx(styles.listItem, { [styles.disabled]: loadingAction })} onClick={loadingAction ? null : onEdit}>
      <div className={cx(link, { 'text-muted': loadingAction })}>
        <i className={cx('me-2', loadingAction === 'edit' ? 'icon-loading icon-spin' : 'icon-pencil-create')} />
        {loadingAction === 'edit' ? 'Loading...' : 'Edit'}
      </div>
    </li>
    {status ? (
      <li
        className={cx(styles.listItem, { [styles.disabled]: loadingAction })}
        onClick={loadingAction ? null : onDeactivate}
      >
        <div className={cx(link, loadingAction ? 'text-muted' : 'text-danger')}>
          <i
            className={cx('me-2', loadingAction === 'deactivate' ? 'icon-loading icon-spin' : 'icon-cross-x', {
              'text-danger': !loadingAction,
            })}
          />
          {loadingAction === 'deactivate' ? 'Deactivating...' : 'Deactivate'}
        </div>
      </li>
    ) : (
      <li
        className={cx(styles.listItem, { [styles.disabled]: loadingAction })}
        onClick={loadingAction ? null : onActivate}
      >
        <div className={cx(link, loadingAction ? 'text-muted' : 'text-primary')}>
          <i
            className={cx('me-2', loadingAction === 'activate' ? 'icon-loading icon-spin' : 'icon-rotate-ccw', {
              'text-primary': !loadingAction,
            })}
          />
          {loadingAction === 'activate' ? 'Activating...' : 'Activate'}
        </div>
      </li>
    )}
  </ul>
);

UserEditMenu.propTypes = {
  onEdit: PropTypes.func.isRequired,
  onDeactivate: PropTypes.func.isRequired,
  onActivate: PropTypes.func.isRequired,
  status: PropTypes.bool.isRequired,
  loadingAction: PropTypes.oneOf([null, 'edit', 'activate', 'deactivate']),
};

UserEditMenu.defaultProps = {
  loadingAction: null,
};

export default UserEditMenu;
